(() => {
  if (document.querySelector('.sccs-referral-nudge')) return;

  const DISCOUNT_CODE = 'SCCSFRIEND10';
  const config = window.SCCSReferral || {};
  const params = new URLSearchParams(window.location.search);
  const incomingToken = params.get('ref');
  const tokenPattern = /^[a-f0-9]{36}$/i;

  const referralStorageKey = 'sccs_referral_token';
  const legacyReferralStorageKey = 'sccs-referrer_customer_id';
  const referralActiveKey = 'sccs-referral-discount-active';
  const referralNoticeDismissedKey = incomingToken && tokenPattern.test(incomingToken)
    ? `sccs-referral-notice-dismissed:${incomingToken.toLowerCase()}`
    : 'sccs-referral-notice-dismissed';
  const referralPendingKey = 'sccs-referral-after-login';

  try { localStorage.removeItem(legacyReferralStorageKey); } catch (_) {}

  const activateFriendReferral = async (token) => {
    if (!tokenPattern.test(token || '')) return false;
    try { localStorage.setItem(referralStorageKey, token.toLowerCase()); } catch (_) {}

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: { sccs_referral_token: token.toLowerCase() }
        })
      });
      if (!response.ok) return false;
      try { localStorage.setItem(referralActiveKey, '1'); } catch (_) {}
      return true;
    } catch (_) {
      return false;
    }
  };

  const showFriendConfirmation = () => {
    if (document.querySelector('.sccs-referral-confirmation')) return;
    const notice = document.createElement('aside');
    notice.className = 'sccs-referral-confirmation';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');

    const title = document.createElement('strong');
    title.className = 'sccs-referral-confirmation-title';
    title.textContent = config.friendTitle || '';
    const copy = document.createElement('span');
    copy.className = 'sccs-referral-confirmation-copy';
    copy.textContent = config.friendCopy || '';
    notice.append(title, copy);
    document.body.appendChild(notice);

    const header = document.querySelector('[data-header]');
    const positionNotice = () => {
      if (!header || !notice.isConnected) return;
      notice.style.setProperty('--sccs-referral-notice-top', `${Math.max(0, Math.round(header.getBoundingClientRect().bottom))}px`);
    };
    positionNotice();
    window.addEventListener('resize', positionNotice);
    window.requestAnimationFrame(() => notice.classList.add('is-visible'));
    window.setTimeout(() => {
      notice.classList.remove('is-visible');
      window.removeEventListener('resize', positionNotice);
      window.setTimeout(() => notice.remove(), 320);
    }, 4800);
  };

  const discountLinkAppliedKey = (token) => `sccs-referral-discount-link:${token.toLowerCase()}`;
  const referralConfirmationPendingKey = 'sccs-referral-confirmation-pending';

  const applyReferralDiscountLink = (token) => {
    let alreadyApplied = false;
    try { alreadyApplied = sessionStorage.getItem(discountLinkAppliedKey(token)) === '1'; } catch (_) {}
    if (alreadyApplied) return false;

    try {
      sessionStorage.setItem(discountLinkAppliedKey(token), '1');
      sessionStorage.setItem(referralConfirmationPendingKey, token.toLowerCase());
    } catch (_) {}

    const redirectUrl = new URL(window.location.href);
    redirectUrl.searchParams.delete('ref');
    const redirectPath = `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}` || '/';
    window.location.replace(`/discount/${encodeURIComponent(DISCOUNT_CODE)}?redirect=${encodeURIComponent(redirectPath)}`);
    return true;
  };

  const syncFriendReferral = async () => {
    let token = incomingToken;
    if (!tokenPattern.test(token || '')) {
      try { token = localStorage.getItem(referralStorageKey); } catch (_) { token = null; }
    }
    if (!tokenPattern.test(token || '')) return;

    const activated = await activateFriendReferral(token);
    if (!activated) return;

    if (tokenPattern.test(incomingToken || '') && applyReferralDiscountLink(token)) return;

    let shouldConfirm = tokenPattern.test(incomingToken || '');
    try {
      if (sessionStorage.getItem(referralConfirmationPendingKey) === token.toLowerCase()) {
        shouldConfirm = true;
        sessionStorage.removeItem(referralConfirmationPendingKey);
      }
    } catch (_) {}
    if (!shouldConfirm) return;

    const noticeKey = `sccs-referral-notice-dismissed:${token.toLowerCase()}`;
    let noticeShown = false;
    try { noticeShown = sessionStorage.getItem(noticeKey) === '1'; } catch (_) {}
    if (noticeShown) return;

    try { sessionStorage.setItem(noticeKey, '1'); } catch (_) {}
    showFriendConfirmation();
  };

  syncFriendReferral();

  const wrap = document.createElement('aside');
  wrap.className = 'sccs-referral-nudge';
  wrap.setAttribute('aria-label', config.offerLabel || '');

  const trigger = document.createElement('button');
  trigger.className = 'sccs-referral-trigger';
  trigger.type = 'button';
  trigger.setAttribute('aria-expanded', 'false');
  trigger.textContent = config.offerLabel || '';

  const panel = document.createElement('div');
  panel.className = 'sccs-referral-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'false');
  panel.setAttribute('aria-labelledby', 'sccs-referral-title');

  const close = document.createElement('button');
  close.className = 'sccs-referral-close';
  close.type = 'button';
  close.setAttribute('aria-label', config.closeLabel || '');
  close.textContent = '×';

  const title = document.createElement('h2');
  title.className = 'sccs-referral-title';
  title.id = 'sccs-referral-title';
  title.textContent = config.panelTitle || '';

  const copy = document.createElement('p');
  copy.className = 'sccs-referral-copy';
  copy.textContent = config.panelCopy || '';

  const mainView = document.createElement('div');
  mainView.className = 'sccs-referral-main';
  const action = document.createElement('button');
  action.className = 'sccs-referral-action';
  action.type = 'button';
  action.textContent = config.inviteLabel || '';
  const copyAction = document.createElement('button');
  copyAction.className = 'sccs-referral-copy-action';
  copyAction.type = 'button';
  copyAction.textContent = config.copyLinkLabel || '';
  const terms = document.createElement('p');
  terms.className = 'sccs-referral-terms';
  terms.textContent = config.terms || '';
  mainView.append(action, copyAction, terms);

  const signInView = document.createElement('div');
  signInView.className = 'sccs-referral-signin';
  signInView.hidden = true;
  const signInTitle = document.createElement('h3');
  signInTitle.className = 'sccs-referral-signin-title';
  signInTitle.textContent = config.signInTitle || '';
  const signInCopy = document.createElement('p');
  signInCopy.className = 'sccs-referral-copy';
  signInCopy.textContent = config.signInCopy || '';
  const signInAction = document.createElement('button');
  signInAction.className = 'sccs-referral-signin-action';
  signInAction.type = 'button';
  signInAction.textContent = config.signInContinue || '';
  const back = document.createElement('button');
  back.className = 'sccs-referral-back';
  back.type = 'button';
  back.textContent = config.backLabel || '';
  signInView.append(signInTitle, signInCopy, signInAction, back);

  panel.append(close, title, copy, mainView, signInView);
  wrap.append(trigger, panel);
  document.body.appendChild(wrap);

  let shown = false;

  const show = () => {
    if (shown) return;
    shown = true;
    wrap.classList.add('is-visible');
    trigger.classList.add('sccs-referral-attention');
    window.setTimeout(() => trigger.classList.remove('sccs-referral-attention'), 3000);
    window.removeEventListener('scroll', onScroll);
  };

  const onScroll = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= 0.18) show();
  };

  const showMainView = () => {
    mainView.hidden = false;
    signInView.hidden = true;
  };

  trigger.addEventListener('click', () => {
    wrap.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    close.focus();
  });

  close.addEventListener('click', () => {
    wrap.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    showMainView();
    trigger.focus();
  });

  back.addEventListener('click', () => {
    showMainView();
    action.focus();
  });

  signInAction.addEventListener('click', () => {
    try { sessionStorage.setItem(referralPendingKey, '1'); } catch (_) {}
    window.location.href = config.loginUrl || '/account/login';
  });

  try {
    if (config.loggedIn && sessionStorage.getItem(referralPendingKey) === '1') {
      sessionStorage.removeItem(referralPendingKey);
      show();
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      showMainView();
      action.textContent = config.shareButtonLabel || config.inviteLabel || '';
    }
  } catch (_) {}

  const getReferralLink = async () => {
    const response = await fetch('/apps/referrals', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    const result = await response.json();
    if (!response.ok || !result.ok || !tokenPattern.test(result.token || '') || !result.referralUrl) throw new Error('referral_link');
    return result.referralUrl;
  };

  copyAction.addEventListener('click', async () => {
    if (!config.loggedIn) {
      mainView.hidden = true;
      signInView.hidden = false;
      signInAction.focus();
      return;
    }

    const original = copyAction.textContent;
    copyAction.disabled = true;
    try {
      const shareUrl = await getReferralLink();
      try {
        await navigator.clipboard.writeText(shareUrl);
        copyAction.textContent = config.copiedLabel || original;
        window.setTimeout(() => { copyAction.textContent = original; }, 2600);
      } catch (_) {
        window.prompt(config.copyPrompt || '', shareUrl);
      }
    } catch (_) {
      copyAction.textContent = config.linkError || original;
      window.setTimeout(() => { copyAction.textContent = original; }, 3200);
    } finally {
      copyAction.disabled = false;
    }
  });

  action.addEventListener('click', async () => {
    if (!config.loggedIn) {
      mainView.hidden = true;
      signInView.hidden = false;
      signInAction.focus();
      return;
    }

    const original = action.textContent;
    action.disabled = true;

    try {
      const shareUrl = await getReferralLink();
      const shareData = {
        title: config.shareTitle || '',
        text: config.shareText || '',
        url: shareUrl
      };

      if (navigator.share) {
        try {
          await navigator.share(shareData);
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }

      try {
        await navigator.clipboard.writeText(shareUrl);
        action.textContent = config.copiedLabel || original;
        window.setTimeout(() => { action.textContent = original; }, 2600);
      } catch (_) {
        window.prompt(config.copyPrompt || '', shareUrl);
      }
    } catch (_) {
      action.textContent = config.linkError || original;
      window.setTimeout(() => { action.textContent = original; }, 3200);
    } finally {
      action.disabled = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && wrap.classList.contains('is-open')) close.click();
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.setTimeout(show, 5000);
})();
